/* Kafie 1901 Coffee — theme behaviour */
(function () {
  'use strict';

  /* ---------- reveal on scroll ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.rv').forEach(function (el, i) {
    el.style.transitionDelay = (i % 4 * 60) + 'ms'; io.observe(el);
  });
  function sweep() {
    document.querySelectorAll('.rv:not(.in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.95 && r.bottom > 0) el.classList.add('in');
    });
  }
  addEventListener('scroll', sweep, { passive: true });
  addEventListener('resize', sweep);
  sweep();

  /* ---------- video: play only while on screen ---------- */
  function wake(v) { if (v.preload === 'none') { v.preload = 'auto'; v.load(); } var p = v.play(); if (p) p.catch(function () {}); }

  var vio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.isIntersecting ? wake(e.target) : e.target.pause(); });
  }, { threshold: 0.15 });
  document.querySelectorAll('video').forEach(function (v) {
    if (v.id !== 'lbv' && !v.closest('.marquee') && !v.closest('.hcar')) vio.observe(v);
  });

  /* the reel wakes as one piece so tiles never scroll in blank;
     the duplicate set trails so first paint isn't waiting on every clip */
  var mq = document.getElementById('marquee');
  if (mq) {
    var sets = mq.querySelectorAll('.marquee__set');
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var on = e.isIntersecting;
        if (sets[0]) sets[0].querySelectorAll('video').forEach(function (v) { on ? wake(v) : v.pause(); });
        var rest = function () { if (sets[1]) sets[1].querySelectorAll('video').forEach(function (v) { on ? wake(v) : v.pause(); }); };
        on ? setTimeout(rest, 2200) : rest();
      });
    }, { threshold: 0.05 }).observe(mq);
  }

  /* ---------- lightbox ---------- */
  var lb = document.getElementById('lb'), lbv = document.getElementById('lbv'), lbc = document.getElementById('lbc');
  function closeLb() { if (!lb) return; lb.classList.remove('open'); lb.setAttribute('aria-hidden', 'true'); lbv.pause(); lbv.removeAttribute('src'); lbv.load(); }
  document.querySelectorAll('.tile').forEach(function (tile) {
    tile.addEventListener('click', function () {
      var v = tile.querySelector('video');
      if (!v || !lb) return;                       /* still-frame only — nothing to open */
      var src = v.currentSrc || (v.querySelector('source') || {}).src;
      if (!src) return;
      lbv.src = src; lbc.textContent = tile.dataset.cap || '';
      lb.classList.add('open'); lb.setAttribute('aria-hidden', 'false');
      var p = lbv.play(); if (p) p.catch(function () {});
    });
  });
  if (lb) {
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('lb__x')) closeLb(); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
  }

  /* ---------- roast filter ---------- */
  var chips = document.querySelectorAll('.filters button');
  var cards = document.querySelectorAll('#grid .card');
  chips.forEach(function (ch) {
    ch.addEventListener('click', function () {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      ch.setAttribute('aria-pressed', 'true');
      var f = ch.dataset.f;
      cards.forEach(function (c) { c.classList.toggle('is-hidden', f !== 'all' && c.dataset.roast !== f); });
    });
  });

  /* ---------- live roast date: the most recent Tuesday ---------- */
  var rdates = document.querySelectorAll('.rdate');
  if (rdates.length) {
    var d = new Date();
    d.setDate(d.getDate() - ((d.getDay() - 2 + 7) % 7));
    var label = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    rdates.forEach(function (e) { e.textContent = label; });
  }

  /* ---------- add to bag without leaving the page ---------- */
  var count = document.getElementById('cartCount');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.querySelectorAll('.card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.add'), original = btn.textContent;
      btn.disabled = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          if (count) count.textContent = cart.item_count;
          btn.textContent = 'Added'; btn.classList.add('done');
        })
        .catch(function () { btn.textContent = 'Try again'; })
        .then(function () {
          setTimeout(function () { btn.textContent = original; btn.classList.remove('done'); btn.disabled = false; }, 1500);
        });
    });
  });

  /* ---------- mobile menu ---------- */
  var burger = document.querySelector('.burger'), mobile = document.getElementById('MobileMenu');
  if (burger && mobile) {
    burger.addEventListener('click', function () {
      var open = mobile.hasAttribute('hidden');
      if (open) { mobile.removeAttribute('hidden'); } else { mobile.setAttribute('hidden', ''); }
      burger.setAttribute('aria-expanded', String(open));
    });
  }
})();
